import Skeleton from "@mui/material/Skeleton";

const SliderSkeleton = () => {
    return(
        <Skeleton variant="rounded" style={{width: "100vw", height: "100vh"}} width={100} height={100} />
    )
}

export default SliderSkeleton